module.exports = __webpack_public_path__ + "8c74398509b2cccf0cfb70bc85dc275a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/logo/full-white-bird.svg
// module id = ./app/images/logo/full-white-bird.svg
// module chunks = 40